import {
  enUS as PickerLocaleEnUs,
  esES as PickerLocaleEsEs,
  ptBR as PickerLocalePtBr,
} from "@mui/x-data-grid-pro/locales";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import { type Locale, enUS, es, ptBR } from "date-fns/locale";
import React, { useEffect, useState } from "react";

import type { IDynamicSchema } from "components/DynamicForms/DynamicTableList/types";
import { LanguagesEnum } from "globalConstants/languagesEnum";
import i18next from "translations/i18n";

const ADAPTER_LOCALES: Record<LanguagesEnum, Locale> = {
  [LanguagesEnum.americanEnglish]: enUS,
  [LanguagesEnum.brazilianPortuguese]: ptBR,
  [LanguagesEnum.spanish]: es,
};

const CustomLocalizationProvider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  const [adapterLocale, setAdapterLocale] = useState<Locale>(ADAPTER_LOCALES[LanguagesEnum.brazilianPortuguese]);

  const localeTextByCurrentLocale: Record<string, IDynamicSchema> = {
    [LanguagesEnum.brazilianPortuguese]: PickerLocalePtBr.components.MuiDataGrid.defaultProps.localeText,
    [LanguagesEnum.americanEnglish]: PickerLocaleEnUs.components.MuiDataGrid.defaultProps.localeText,
    [LanguagesEnum.spanish]: PickerLocaleEsEs.components.MuiDataGrid.defaultProps.localeText,
  };

  useEffect(() => {
    i18next.on("languageChanged init", () => {
      if (i18next.language) {
        const updatedAdapterLocale = ADAPTER_LOCALES[i18next.language as keyof typeof ADAPTER_LOCALES];
        setAdapterLocale(updatedAdapterLocale);
      }
    });

    return i18next.off("languageChanged init");
  }, []);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      localeText={localeTextByCurrentLocale[i18next.language]}
      adapterLocale={adapterLocale}
    >
      {children}
    </LocalizationProvider>
  );
};

export default CustomLocalizationProvider;
